import React from "react";
import EsriAuthWrapper from "../../components/map/EsriAuthWrapper";

export function PreComponentWrapper({children, config}) {

	const esriIdentity = config?.configuration?.element?.esriIdentity;

	return (
		<React.Fragment>
			{esriIdentity &&
				<React.Fragment>
					<EsriAuthWrapper appId={esriIdentity.appId} portalUrl={esriIdentity.portalUrl}>
						{children}
					</EsriAuthWrapper>
				</React.Fragment>
			}
			{!esriIdentity &&
				<React.Fragment>
					{children}
				</React.Fragment>
			}

		</React.Fragment>
	)
}